<template>
	<div class="sticky-side-flyout">
		<h3>{{ subHeading }}</h3>
		<span>{{ videoTitle }}</span>
		<div id="fullscreen-button">
			<svg
				width="20"
				height="21"
				viewBox="0 0 20 21"
				fill="none"
				xmlns="http://www.w3.org/2000/svg"
			>
				<mask
					id="mask0_98_11360"
					style="mask-type: alpha"
					maskUnits="userSpaceOnUse"
					x="0"
					y="0"
					width="20"
					height="21"
				>
					<rect
						y="0.799988"
						width="20"
						height="20"
						fill="#D9D9D9"
					/>
				</mask>
				<g mask="url(#mask0_98_11360)">
					<path
						d="M5 15.8H7C7.28333 15.8 7.52083 15.8958 7.7125 16.0875C7.90417
                        16.2792 8 16.5167 8 16.8C8 17.0833 7.90417 17.3208 7.7125 17.5125C7.52083
                        17.7042 7.28333 17.8 7 17.8H4C3.71667 17.8 3.47917 17.7042 3.2875
                        17.5125C3.09583 17.3208 3 17.0833 3 16.8V13.8C3 13.5167 3.09583
                        13.2792 3.2875 13.0875C3.47917 12.8958 3.71667 12.8 4 12.8C4.28333
                        12.8 4.52083 12.8958 4.7125 13.0875C4.90417 13.2792 5 13.5167 5
                        13.8V15.8ZM5 5.79999V7.79999C5 8.08332 4.90417 8.32082 4.7125
                        8.51249C4.52083 8.70415 4.28333 8.79999 4 8.79999C3.71667 8.79999
                        3.47917 8.70415 3.2875 8.51249C3.09583 8.32082 3 8.08332 3
                        7.79999V4.79999C3 4.51665 3.09583 4.27915 3.2875 4.08749C3.47917
                        3.89582 3.71667 3.79999 4 3.79999H7C7.28333 3.79999 7.52083
                        3.89582 7.7125 4.08749C7.90417 4.27915 8 4.51665 8 4.79999C8
                        5.08332 7.90417 5.32082 7.7125 5.51249C7.52083 5.70415 7.28333 5.79999 7
                        5.79999H5ZM15 15.8V13.8C15 13.5167 15.0958 13.2792 15.2875 13.0875C15.4792
                        12.8958 15.7167 12.8 16 12.8C16.2833 12.8 16.5208 12.8958
                        16.7125 13.0875C16.9042
                        13.2792 17 13.5167 17 13.8V16.8C17 17.0833 16.9042 17.3208
                        16.7125 17.5125C16.5208
                        17.7042 16.2833 17.8 16 17.8H13C12.7167 17.8 12.4792
                        17.7042 12.2875 17.5125C12.0958
                        17.3208 12 17.0833 12 16.8C12 16.5167
                        12.0958 16.2792 12.2875 16.0875C12.4792
                        15.8958 12.7167 15.8 13 15.8H15ZM15 5.79999H13C12.7167
                        5.79999 12.4792 5.70415
                        12.2875 5.51249C12.0958 5.32082 12 5.08332 12 4.79999C12
                        4.51665 12.0958 4.27915
                        12.2875 4.08749C12.4792 3.89582 12.7167 3.79999 13
                        3.79999H16C16.2833 3.79999
                        16.5208 3.89582 16.7125 4.08749C16.9042 4.27915 17
                        4.51665 17 4.79999V7.79999C17
                        8.08332 16.9042 8.32082 16.7125 8.51249C16.5208
                        8.70415 16.2833 8.79999 16
                        8.79999C15.7167 8.79999 15.4792 8.70415 15.2875
                        8.51249C15.0958 8.32082
                        15 8.08332 15 7.79999V5.79999Z"
						fill="black"
					/>
				</g>
			</svg>
		</div>
	</div>
</template>

<script>
export default {
	props: {
		subHeading: {
			type: String,
			default: '',
		},
		videoTitle: {
			type: String,
			default: '',
		},
	},
};
</script>
